// src/RoomModal.js - VERSIONE CORRETTA

import React, { useState, useEffect } from 'react';

// Stili per la lista e i suoi elementi
const listStyles = {
    listStyle: 'none',
    padding: '10px',
    margin: '10px 0 0 0',
    maxHeight: '200px',
    overflowY: 'auto',
    border: '1px solid #ddd',
    borderRadius: '5px',
};
const itemStyles = {
    padding: '10px 5px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    borderBottom: '1px solid #f0f0f0',
};
const lastItemStyles = { ...itemStyles, borderBottom: 'none' };
const checkboxStyles = {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    flexShrink: 0,
};
const labelStyles = {
    cursor: 'pointer',
    flexGrow: 1,
};


export function RoomModal({ roomData, allEquipment, onSave, onClose }) {
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [capacity, setCapacity] = useState(1); // 🎯 NUOVO: Stato per la capienza
    // 🆕 Colore personalizzato della stanza (nessun default: se non impostato,
    // in Agenda.jsx si ricade sul colore del medico assegnato, come prima).
    const [color, setColor] = useState('');
    const [selectedEquipmentIds, setSelectedEquipmentIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (roomData) {
            setName(roomData.name || '');
            setNumber(roomData.number || '');
            setCapacity(roomData.capacity || 1); // 🎯 NUOVO: Carica la capienza esistente
            setColor(roomData.color || ''); // 🆕 Nessun default: stringa vuota se non impostato
            setSelectedEquipmentIds(roomData.equipmentIds || []);
        }
    }, [roomData]);
    
    const handleEquipmentToggle = (equipmentId) => {
        setSelectedEquipmentIds(prevIds =>
            prevIds.includes(equipmentId)
                ? prevIds.filter(id => id !== equipmentId)
                : [...prevIds, equipmentId]
        );
    };

    const handleSave = () => {
        if (!name || !number) {
            alert('Nome e Numero sono obbligatori.');
            return;
        }
        onSave({
            id: roomData?.id,
            name: name.trim(),
            number: parseInt(number),
            capacity: parseInt(capacity) || 1, // 🎯 NUOVO: Passa la capienza al salvataggio
            color: color || null, // 🆕 null = nessun colore personalizzato, usa il fallback sul medico
            equipmentIds: selectedEquipmentIds,
        });
    };

    const filteredEquipment = [...allEquipment]
        .sort((a, b) => a.name.localeCompare(b.name)) // Ordinamento
        .filter(equip => equip.name.toLowerCase().includes(searchTerm.toLowerCase())); // Ricerca

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()} style={{maxWidth: '500px'}}>
                <h3 style={{ textAlign: 'left' }}>{roomData ? 'Modifica Stanza' : 'Nuova Stanza'}</h3>
                
                {/* --- CONTENITORE CON TESTO ALLINEATO A SINISTRA --- */}
                <div style={{ textAlign: 'left' }}>
                    <div className="management-form" style={{ background: 'none', boxShadow: 'none', padding: 0, marginTop: '15px', display: 'grid', gap: '15px' }}>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome stanza" />
                        {/* 🎯 NUOVO: Affianchiamo Numero Stanza e Capienza */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <label style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 'bold' }}>Numero Stanza</label>
                                <input type="number" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="Es. 1" />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <label style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 'bold' }}>Capienza Max Pazienti</label>
                                <input type="number" min="1" value={capacity} onChange={(e) => setCapacity(e.target.value)} placeholder="Es. 1" />
                            </div>
                        </div>
                        {/* 🆕 Colore personalizzato: utile soprattutto per stanze con più
                            collaboratori, dove altrimenti in Agenda si vedrebbe il colore
                            del medico assegnato di volta in volta. Nessun colore = fallback automatico. */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <label style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 'bold' }}>Colore Colonna Agenda (opzionale)</label>
                            <input type="color" value={color || '#ffffff'} onChange={(e) => setColor(e.target.value)} style={{ width: '40px', height: '30px', padding: 0, border: '1px solid #d1d5db', borderRadius: '4px', cursor: 'pointer' }} />
                            {color && (
                                <button type="button" onClick={() => setColor('')} style={{ fontSize: '0.75rem', color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
                                    Rimuovi colore
                                </button>
                            )}
                        </div>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <label style={{fontWeight: 'bold'}}>Macchinari presenti nella stanza:</label>
                        
                        <input
                            type="text"
                            placeholder="Cerca macchinario..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', padding: '10px', fontSize: '1rem', boxSizing: 'border-box', margin: '10px 0 0 0' }}
                        />

                        <ul style={listStyles}>
                            {filteredEquipment.map((equip, index) => (
                                <li key={equip.id} style={index === filteredEquipment.length - 1 ? lastItemStyles : itemStyles}>
                                    <input
                                        type="checkbox"
                                        id={`equip-${equip.id}`}
                                        checked={selectedEquipmentIds.includes(equip.id)}
                                        onChange={() => handleEquipmentToggle(equip.id)}
                                        style={checkboxStyles}
                                    />
                                    <label htmlFor={`equip-${equip.id}`} style={labelStyles}>{equip.name}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* I pulsanti rimangono centrati per estetica */}
                <div style={{ textAlign: 'center' }}>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '20px' }}>Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}